export const shouldTruncate = (str, length) => str.length > length;
